import apiFetch from '@/utils/apiFetch';
import { defineStore } from 'pinia';
import DefaultConfig from '@/config/default';
import { computed } from 'vue';

// eslint-disable-next-line import/prefer-default-export
export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: null as string | null,
    loading: false,
    error: null as string | null,
    user: null as NonNullable<unknown> | null,
    purpose: null as string | null,
    permissions: null as NonNullable<unknown> | null,
  }),

  actions: {
    async login(emailAddress: string, password: string) {
      this.error = null;
      this.loading = true;

      const defaultConfig = new DefaultConfig();

      try {
        const credentials = btoa(`${defaultConfig.apiKey}:${defaultConfig.apiSecret}`);
        const res = await apiFetch(`${defaultConfig.baseURL}/api/auth/public/users/authenticate`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Basic ${credentials}`,
          },
          body: JSON.stringify({ emailAddress, password }),
        });
        if (!res.ok) {
          throw new Error('Invalid credentials');
        }
        const data = await res.json();
        this.token = `${data.data.authToken.token}.${data.data.authToken.pubKey}`;
        this.purpose = data.data.authToken.purpose;
        this.user = data.data.user;
        localStorage.setItem('token', this.token);
        localStorage.setItem('user', JSON.stringify(this.user));
        localStorage.setItem('permissions', data.data.permissions);
        localStorage.setItem('purpose', this.purpose || '');
        console.log(localStorage.getItem('permissions'));
      } catch (err: any) {
        this.error = err.message || 'Something went wrong';
      } finally {
        this.loading = false;
      }
    },

    async getPermissions() {
      this.error = null;
      this.loading = true;

      const defaultConfig = new DefaultConfig();
      const token = localStorage.getItem('token');
      try {
        const res = await apiFetch(`${defaultConfig.baseURL}/api/auth/public/permissions`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        if (!res.ok) {
          throw new Error('Invalid credentials');
        }
        const data = await res.json();
        this.permissions = data.data.results;
        console.log(localStorage.getItem('permissions'));
      } catch (err: any) {
        this.error = err.message || 'Something went wrong';
      } finally {
        this.loading = false;
      }
    },

    async assignPermission(permissionId: string, userId: string) {
      this.error = null;
      this.loading = true;

      const defaultConfig = new DefaultConfig();
      const token = localStorage.getItem('token');
      try {
        const res = await apiFetch(`${defaultConfig.baseURL}/api/auth/public/permissions`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ permissionId, userId }),
        });
        if (!res.ok) {
          throw new Error('Invalid credentials');
        }
        const data = await res.json();
        this.permissions = data.data.results;
        console.log(localStorage.getItem('permissions'));
      } catch (err: any) {
        this.error = err.message || 'Something went wrong';
      } finally {
        this.loading = false;
      }
    },

    hasPermissions(permission: string, expectedPurpose: string) {
      const purpose = localStorage.getItem('purpose');
      if (purpose !== expectedPurpose) return false;

      const permissions = localStorage.getItem('permissions');
      if (!permissions) return false;
      const permissionList = permissions.split(',').map((p) => p.trim().toLowerCase());
      return permissionList.includes(permission);
    },

    logout() {
      this.token = null;
      this.user = null;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('permissions');
      localStorage.removeItem('purpose');
    },

    initializeAuth() {
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user');
      if (token && user) {
        this.token = token;
        this.user = JSON.parse(user);
      }
    },
  },
});
